const _ = require('lodash');

/**
 * Perform a shallow clone of an object.
 * The returned value is a different object, but any properties that were objects remain as references to the same
 * ones are the original.
 * This differs from using Object.assign because the result will have the same prototype (same 'instanceof'
 * as the original).
 *
 * Use this helper function instead of a library such as lodash directly so we can change the implementation in future.
 *
 * @param {object} original
 *
 * @returns {object}
 */
const cloneShallow = (original) => _.clone(original); // lodash does everything we need for the time being.

/**
 * Perform a shallow clone of an object with a shallow clone of any of its array properties.
 * The returned value is a different object but any properties that were objects remain as references to the same
 * ones are the original, except arrays which will be cloned too (the array itself, not any values within it - those
 * are still pointers to the same object).
 *
 * When you are doing a shallow clone this is probably the more useful behaviour than cloneShallow alone.
 *
 * @param {object} original
 *
 * @returns {object}
 */
const cloneShallowPlusArrays = (original) => {
    // clone from lodash does everything we need for the time being.
    let cloned = cloneShallow(original);
    Object.keys(cloned).forEach((key) => {
        if (cloned[key] instanceof Array) {
            cloned[key] = cloneShallow(cloned[key]);
        }
    });
    return cloned;
};

/**
 * Perform a deep clone of an object.
 * The returned value is a different object and any properties that were object are also cloned recursively.
 *
 * Use this helper function instead of a library such as lodash directly so we can change the implementation in future.
 *
 * @param {object} original
 *
 * @returns {object}
 */
const cloneDeep = (original) => _.cloneDeep(original); // lodash does everything we need for the time being.

module.exports = {
    cloneShallow,
    cloneShallowPlusArrays,
    cloneDeep,
};
